import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useCameraModes } from "@features/camera/modes";
import { Page } from "@views/layout/layout";
import { motion } from "framer-motion";
import {
  PacksGrid,
  TryonGrid,
  HaircutsGrid,
  MemesGrid,
  TemplatesToolbar,
} from "./components";

type CategoryType = "pack" | "tryon" | "haircut" | "image";

export const TemplatesPage = () => {
  const [searchParams] = useSearchParams();
  const urlMode = searchParams.get("mode") as CategoryType | null;
  const { modes } = useCameraModes();

  // Get the first available mode as default
  const getDefaultCategory = (): CategoryType => {
    if (urlMode && modes[urlMode]) return urlMode;
    if (modes.pack) return "pack";
    if (modes.tryon) return "tryon";
    if (modes.haircut) return "haircut";
    if (modes.image) return "image";
    return "pack";
  };

  const [activeCategory, setActiveCategory] = useState<CategoryType>(
    getDefaultCategory()
  );
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <Page verticalCenter={false}>
      <div className="w-full space-y-4 pb-8">
        <TemplatesToolbar
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />

        <motion.div
          className="px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, ease: "easeOut", delay: 0.1 }}
        >
          {activeCategory === "pack" && (
            <PacksGrid
              searchQuery={searchQuery}
              urlProject={searchParams.get("project")}
              urlModel={searchParams.get("model")}
            />
          )}
          {activeCategory === "tryon" && (
            <TryonGrid searchQuery={searchQuery} />
          )}
          {activeCategory === "haircut" && (
            <HaircutsGrid searchQuery={searchQuery} />
          )}
          {activeCategory === "image" && (
            <MemesGrid searchQuery={searchQuery} />
          )}
        </motion.div>
      </div>
    </Page>
  );
};
